import React from 'react'
import styled from 'styled-components'

export const RequiredBudge = () => {
  return <Budge>必須</Budge>
}

const Budge = styled.span`
  background: #f55852;
  border-radius: 2px;
  color: #fff;
  font-weight: 600;
  font-size: 11px;
  padding: 4px;
  white-space: nowrap;
  vertical-align: middle;
`
